module.exports = __webpack_public_path__ + "img/logout.9cc592fd.svg";